
import React from 'react';

type TableProps = React.TableHTMLAttributes<HTMLTableElement>;

export const DivTable = (className?: string) => {
	return function WrappedTable(props: TableProps) {
		return (
			<div className={className}>
				<table {...props} />
			</div>
		);
	};
};
